import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { isPast } from 'date-fns';

import { useMonetaryAmount } from '@sorare/core/src/hooks/useMonetaryAmount';

import type { useGetTokenSingleSaleDetails_anyCard } from './__generated__/useGetTokenSingleSaleDetails.graphql.ts';

export const useGetTokenSingleSaleDetails = (
  card: Nullable<useGetTokenSingleSaleDetails_anyCard>
) => {
  const { toMonetaryAmount } = useMonetaryAmount();
  const singleSaleOffer =
    card?.liveSingleSaleOffer || card?.myMintedSingleSaleOffer;
  const endDate = singleSaleOffer?.endDate;
  const price = singleSaleOffer?.receiverSide?.amounts;
  const isOnSale = !!singleSaleOffer;

  if (isOnSale && price && endDate) {
    const ended = isPast(endDate);
    return {
      endDate,
      ended,
      price: toMonetaryAmount(price),
    };
  }
  return undefined;
};

useGetTokenSingleSaleDetails.fragments = {
  anyCard: gql`
    fragment useGetTokenSingleSaleDetails_anyCard on AnyCardInterface {
      slug
      myMintedSingleSaleOffer @skip(if: $onlyPrimary) {
        id
        endDate
        receiverSide {
          id
          amounts {
            ...useMonetaryAmount_monetaryAmount
          }
        }
      }
      liveSingleSaleOffer @skip(if: $onlyPrimary) {
        id
        endDate
        receiverSide {
          id
          amounts {
            ...useMonetaryAmount_monetaryAmount
          }
        }
      }
    }
    ${useMonetaryAmount.fragments.monetaryAmount}
  ` as TypedDocumentNode<useGetTokenSingleSaleDetails_anyCard>,
};
